import { RouteObject } from "react-router-dom";

import * as Sentry from "@sentry/react";

import { ArchiveProcedure } from "@/components/Archive/Pages/ArchiveProcedure/ArchiveProcedure";

import PageError from "@/helpers/components/Errors/PageError";

export const ArchiveRoutes: RouteObject = {
	path: "archive/*",
	children: [
		{
			index: true,
			lazy: async () => {
				const { Archive } = await import("@/components/Archive/Pages/Archive");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<Archive />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: "procedure/:id",
			children: [
				{
					index: true,
					lazy: async () => {
						const { Archive } = await import(
							"@/components/Archive/Pages/Archive"
						);
						return { Component: ArchiveProcedure };
					},
				},
				{
					path: "data",
					lazy: async () => {
						const { ArchiveDataGridPage } = await import(
							"@/components/Archive/Pages/DataGrid/ArchiveDataGridPage"
						);
						return { Component: ArchiveDataGridPage };
					},
				},
			],
		},
	],
};
